import React, { useCallback, useEffect, useState } from 'react';

import DataGrid from 'react-data-grid';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

import { Tabela } from './styles';
import api from '../../../services/api';
import Button from '../../Button';



interface Vendas {
  cd: number;
  usuario: string;
  caixa: string;
  data_abertura: string;
  cd_caixa: number;
  login: string;
  dt_abert: string;
  cd_prod: number;
  nm_prod: string;
  obs: string;
  forma: string;
  qtd: number;
  unid: number;
  dinheiro: number;
  cheque: number;
  fiado: number;
  pago: number;
  subtot: number;
  cartao: number;
  pix: number;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const defaultColumnProperties = {
  resizable: true,
};

const columnsVenda = [
  { key: 'Cartao', name: 'Cartao', width:250},
  {
    key: 'Dinheiro',
    name: 'Dinheiro',
    width: 250,
  },
  {
    key: 'Pix',
    name: 'Pix',
    width: 250,
  },
  {
    key: 'Cheque',
    name: 'Cheque',
    width: 250,
  },
  {
    key: 'Fiado',
    name: 'Fiado',
    width: 250,
  },
].map((c) => ({ ...c, ...defaultColumnProperties }));
const columnsVendasProdutos = [
  {
    key: 'cdProd',
    name: 'Cd',
    width: 45,
  },
  { key: 'NomeProduto', name: 'Produto' },

  {
      key: 'Login',
      name: 'Login',
      width: 100 ,
    }, 
    {
      key: 'Obs',
      name: 'Observação',
      width: 275,
    },
    { key: 'Forma', name: 'Forma', width: 65 },
  {
    key: 'unid',
    name: 'Unidade',
    width: 90,
  },
  {
    key: 'Quantidade',
    name: 'Qtd',
    width: 45,
  },
  {
      key: 'Cartao',
      name: 'Cartao',
      width: 90,
  },
  {
    key: 'Pix',
    name: 'Pix',
    width: 90,
},
  {
    key: 'Dinheiro',
    name: 'Dinheiro',
    width: 85,
  },
  {
    key: 'Cheque',
    name: 'Cheque',
    width: 65,
  },
  {
    key: 'Fiado',
    name: 'Fiado',
    width: 90,
  },
  {
    key: 'VlPago',
    name: 'Valor Pago',
    width: 100,
  },
].map((c) => ({ ...c, ...defaultColumnProperties }));

const EmptyRowsView = () => {
  const message = 'Ops, não há dados disponíveis para as datas selecionadas...';
  return (
    <div style={{ textAlign: 'center', padding: '100px' }}>
      <h3>{message}</h3>
    </div>
  );
};

interface VendaProps {
  dt_inicial: string;
  dt_final: string;
}

const Vendas: React.FC<VendaProps> = ({
  dt_inicial,
  dt_final,
  ...rest
}) => {
  const [rowsVenda, setRowsVenda] = useState([] as any);
  const [rowsVendasProdutos, setRowsVendasProdutos] = useState([] as any);
  const [
    rowsVendasProdutosPorVendas,
    setRowsVendasPorProdutosPorVendas,
  ] = useState([] as any);
  const [vendaClicada, setVendaClicada] = useState([] as any);
  const [totalVendas, setTotalVendas] = useState([] as any);
  const [totalPagamento, setTotalPagamento] = useState([] as any);
  // caixas

  const [cdCaixa, setCaixasArray] = React.useState<string[]>([]);

  const cd_empresa = sessionStorage.getItem('cd');

  const handleChange = (event: SelectChangeEvent<typeof cdCaixa>) => {
    const {
      target: { value },
    } = event;
    setCaixasArray(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  console.log(cdCaixa)


  // caixas

  useEffect(() => {
    api
      .get<Vendas[]>('reports/VendasPorCaixa', {
        params: {
          cdCaixa,
          cd_empresa,
        },
      })
      .then((response) => {
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
        let somar = 0;
        let somaCartao = 0;
        let somaDinheiro = 0;
        let somaPix = 0;
        let somaFiado = 0;
        let somacheque = 0;
        const totalFormasPagamentos = [] as Array<any>;
        const itemsFormatted = [] as Array<any>;
        response.data.forEach((venda) => {
          itemsFormatted.push({
            cdProd: venda.cd,
            NomeProduto: venda.nm_prod,
            Obs: venda.obs,
            unid: venda.unid,
            Data_abertura: venda.dt_abert,
            Cd_Caixa: venda.cd_caixa,
            Login: venda.login,
            Dinheiro: venda.dinheiro,
            Cheque: venda.cheque,
            Quantidade: venda.qtd,
            Pix: venda.pix,
            Cartao: venda.cartao,
            VlPago: formatter.format(venda.pago),
            Fiado: formatter.format(venda.fiado),
            Forma: venda.forma,
            Subtotal: formatter.format(venda.subtot),
          });
          somar += venda.pago;
          somaCartao += venda.cartao;
          somaDinheiro += venda.dinheiro;
          somaPix += venda.pix;
          somaFiado += venda.fiado;
          somacheque += venda.cheque;
        });
        response.data.forEach((pag) => {
          totalFormasPagamentos.push({
            Cartao: formatter.format(somaCartao),
            Dinheiro: formatter.format(somaDinheiro),
            Pix: formatter.format(somaPix),
            Cheque: formatter.format(somacheque),
            Fiado: formatter.format(somaFiado),
          });
        });
        setTotalPagamento(totalFormasPagamentos);
        setTotalVendas(formatter.format(somar));
        setRowsVendasProdutos(itemsFormatted);
      })
      .catch(() => {
        setRowsVendasProdutos([]);
        setTotalPagamento([]);
      });
    api
      .get<Vendas[]>('reports/caixas', {
        params: {
          dt_inicial,
          dt_final,
          cdCaixa,
          cd_empresa
        },
      })
      .then((response) => {
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
        const itemsFormattedVenda = [] as Array<any>;
        response.data.forEach((venda) => {
          itemsFormattedVenda.push({
            Usuario: venda.usuario,
            Caixa: venda.caixa,
            Data_abertura: venda.data_abertura,
          });
        });
        setRowsVenda(itemsFormattedVenda);
      })
      .catch(() => {
        setRowsVenda([]);
      });
  }, [cdCaixa, cd_empresa, dt_final, dt_inicial]);

  const abrirFechar = useCallback(
    (caixa) => {
      if (vendaClicada == caixa) {
        setVendaClicada('');
      } else {
        const vendasProdutos = rowsVendasProdutos.filter(
          (ven: any) => ven.Caixa == caixa,
        );
        setRowsVendasPorProdutosPorVendas([...vendasProdutos]);
        setVendaClicada(caixa);
      }
    },
    [vendaClicada, rowsVendasProdutos],
  );
  return (
    <>

      <Tabela>
        <div>
          <FormControl sx={{ m: 1, width: 300 }}>
            <InputLabel id="demo-multiple-checkbox-label">Tag</InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              multiple
              value={cdCaixa}
              onChange={handleChange}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={MenuProps}
            >
              {rowsVenda.map((name: any) => (
                <MenuItem key={name.Caixa} value={name.Caixa}>
                  <Checkbox checked={cdCaixa.indexOf(name.Caixa) > -1} />
                  <ListItemText primary={`${name.Usuario} | ${name.Caixa}`} secondary={name.Data_abertura} />

                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        {rowsVenda &&
        // {<h1>VALOR TOTAL DE VENDAS :{totalVendas || 'R$: 0,00'}</h1>}
          rowsVenda.map((venda: any, index: number) => (
            <React.Fragment key={venda.cdProd}>
              {index === 0 && (
                <Button onClick={() => abrirFechar(venda.cdProd)} color="white">
                  VALOR TOTAL DE VENDAS :{totalVendas || 'R$: 0,00'}
                </Button>
              )}
              {index === 0 && venda.cdProd === vendaClicada && (
                <DataGrid
                  columns={columnsVendasProdutos}
                  rowGetter={(i) => rowsVendasProdutosPorVendas[i]}
                  rowsCount={rowsVendasProdutosPorVendas.length}
                  minHeight={400}
                  emptyRowsView={EmptyRowsView}
                />
              )}
            </React.Fragment>
          ))}

      </Tabela>
      {totalPagamento[0] && (
        <Tabela>
          <DataGrid
            columns={columnsVenda}
            rowGetter={(i) => totalPagamento[i]}
            rowsCount={1}
            minHeight={400}
            emptyRowsView={EmptyRowsView}
          />
        </Tabela>
      )}
    </>
  );
};

export default Vendas;
